<app-header-style-one></app-header-style-one>
<div class="page-title-area " [ngStyle]="createImgPathBackGround(createImgPath(user?.userImage))">
    <div class="container">
        <div class="page-title-content">
            <h2>{{'MENU.Welcome' | translate}} {{user?.firstName}}</h2>
        </div>
        <div class="circle-image">
            <img [src]="createImgPath(user?.firstName)">
        </div>
    </div>
</div>


<div class="my-dashboard-area ptb-100">
    <div class="container">
       
    </div>
</div>
<app-footer></app-footer>